export default __webpack_public_path__ + "static/media/awaiting0S.f4e6f0fb.svg";